import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";


export const get_seller = createAsyncThunk(
    'seller/get_seller',
    async (sellerId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`home/seller/${sellerId}`);
            // Instead of always expecting data.seller, just use data directly
            return fulfillWithValue(data.seller || data);
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);



// End Method

export const get_category = createAsyncThunk(
    'product/get_category',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/get-categorys')
            console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method
export const get_products = createAsyncThunk(
    'product/get_products',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/get-products')
            console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method

export const get_products_by_seller = createAsyncThunk(
    'product/get_products_by_seller',
    async (sellerId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/shop/get-products-by-seller/${sellerId}`);
            console.log("👉 API response:", data);
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method

export const price_range_product = createAsyncThunk(
    'product/price_range_product',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/price-range-latest-product')
            console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method 

export const query_products = createAsyncThunk(
    'product/query_products',
    async (query, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/query-products', {
                params: {
                    category: query.category || '',
                    subCategory: query.subCategory || '',
                    rating: query.rating || '',
                    lowPrice: query.low || '',
                    highPrice: query.high || '',
                    sortPrice: query.sortPrice || '',
                    pageNumber: query.pageNumber || 1,
                    searchValue: query.searchValue ? query.searchValue : '',
                    filters: query.filters && Object.keys(query.filters).length
                        ? JSON.stringify(query.filters)
                        : ''
                }
            })
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method

export const query_seller_products = createAsyncThunk(
    "home/query_seller_products",
    async ({ low, high, rating, sortPrice, pageNumber, sellerId }, { rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/shop/query-seller-products?sellerId=${sellerId}&low=${low}&high=${high}&rating=${rating}&sortPrice=${sortPrice}&pageNumber=${pageNumber}`);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// End Method

export const query_bulk_products = createAsyncThunk(
    "products/query_bulk_products",
    async ({ low, high, rating, sortPrice, pageNumber }, { rejectWithValue }) => {
        try {
            const { data } = await api.get("/home/products/bulk-query", {
                params: { low, high, rating, sortPrice, pageNumber },
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// End Method

export const query_wholesale_products = createAsyncThunk(
    "products/query_wholesale_products",
    async ({ low, high, rating, sortPrice, pageNumber }, { rejectWithValue }) => {
        try {
            const { data } = await api.get("/home/products/wholesale-query", {
                params: { low, high, rating, sortPrice, pageNumber },
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// End Method

export const product_details = createAsyncThunk(
    'product/product_details',
    async (slug, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/product-details/${slug}`)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method

export const customer_review = createAsyncThunk(
    'review/customer_review',
    async (info, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.post('/home/customer/submit-review', info)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method


export const get_reviews = createAsyncThunk(
    'review/get_reviews',
    async ({ productId, pageNumber }, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/get-reviews/${productId}?pageNo=${pageNumber}`)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method 


export const get_category_filters = createAsyncThunk(
    'product/get_category_filters',
    async (category, { fulfillWithValue, rejectWithValue }) => {
        try {
            const params = typeof category === 'object' && category !== null
                ? category
                : { category };
            const { data } = await api.get('/home/get-filters', { params })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method

export const get_banners = createAsyncThunk(
    'banner/get_banners',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/banners`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method

export const get_mid_banners = createAsyncThunk(
    'banner/get_mid_banners',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/mid-banners`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
// End Method

// ---------------------------------------------------
// 🔍 GET SEARCH SUGGESTIONS
// ---------------------------------------------------
export const getSearchSuggestions = createAsyncThunk(
    'search/getSearchSuggestions',
    async (query, { rejectWithValue }) => {
        try {
            const { data } = await api.get(
                `home/search/suggestions?query=${query}`
            );
            console.log('suggestions:', data)
            return data;

        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: 'Something went wrong' }
            );
        }
    }
);




export const homeReducer = createSlice({
    name: 'home',
    initialState: {
        seller: null,
        categorys: [],
        products: [],
        totalProduct: 0,
        parPage: 3,
        seller_products: [],
        latest_product: [],
        topRated_product: [],
        discount_product: [],
        bulk_products: [],
        wholesale_products: [],
        priceRange: {
            low: 0,
            high: 100
        },
        product: {},
        relatedProducts: [],
        moreProducts: [],
        errorMessage: '',
        successMessage: '',
        totalReview: 0,
        rating_review: [],
        reviews: [],
        banners: [],
        mid_banners: [],
        categoryFilters: [],
        suggestions: {
            categories: [],
            products: [],
        },
        loading: false,
        error: null,

    },
    reducers: {

        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        },
        clearSuggestions: (state) => {
            state.suggestions = { categories: [], products: [] };
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(get_category.fulfilled, (state, { payload }) => {
                state.categorys = payload?.categorys || [];
            })
            .addCase(get_products.fulfilled, (state, { payload }) => {
                state.products = payload?.products || [];
                state.latest_product = payload?.latest_product || [];
                state.topRated_product = payload?.topRated_product || [];
                state.discount_product = payload?.discount_product || [];
            })
            .addCase(get_products_by_seller.fulfilled, (state, { payload }) => {
                state.seller_products = payload.seller_products || [];
                state.latest_product = payload.latest_product || [];
                state.topRated_product = payload.topRated_product || [];
                state.discount_product = payload.discount_product || [];
            })

            .addCase(price_range_product.fulfilled, (state, { payload }) => {
                state.latest_product = payload?.latest_product || [];
                state.priceRange = payload?.priceRange || state.priceRange;
            })
            .addCase(query_products.fulfilled, (state, { payload }) => {
                state.products = payload?.products || [];
                state.totalProduct = payload?.totalProduct || 0;
                state.parPage = payload?.parPage || state.parPage;
            })
            .addCase(query_seller_products.fulfilled, (state, action) => {
                state.loading = false;
                state.seller_products = action.payload?.products || [];
                state.totalProduct = action.payload?.totalProduct || 0;
                state.parPage = action.payload?.parPage || 12;
            })
            .addCase(query_bulk_products.fulfilled, (state, { payload }) => {
                state.bulk_products = payload?.products || [];
                state.totalProduct = payload?.totalProduct || 0;
            })

            .addCase(query_wholesale_products.fulfilled, (state, { payload }) => {
                state.wholesale_products = payload?.products || [];
                state.totalProduct = payload?.totalProduct || 0;
            })

            .addCase(product_details.fulfilled, (state, { payload }) => {
                state.product = payload?.product || {};
                state.relatedProducts = payload?.relatedProducts || [];
                state.moreProducts = payload?.moreProducts || [];
            })

            .addCase(customer_review.fulfilled, (state, { payload }) => {
                state.successMessage = payload?.message || '';
            })

            .addCase(get_reviews.fulfilled, (state, { payload }) => {
                state.reviews = payload?.reviews || [];
                state.totalReview = payload?.totalReview || 0;
                state.rating_review = payload?.rating_review || [];
            })

            .addCase(get_banners.fulfilled, (state, { payload }) => {
                state.banners = payload?.banners || [];
            })
            .addCase(get_mid_banners.fulfilled, (state, { payload }) => {
                state.mid_banners = payload?.banners || [];
            })
            .addCase(get_category_filters.fulfilled, (state, { payload }) => {
                state.categoryFilters = payload?.filters || [];
            })

            .addCase(get_seller.fulfilled, (state, { payload }) => {
                state.seller = payload;
            })
            .addCase(getSearchSuggestions.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSearchSuggestions.fulfilled, (state, action) => {
                state.loading = false;
                state.suggestions = action.payload;
            })
            .addCase(getSearchSuggestions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });



    }
})
export const { messageClear, clearSuggestions } = homeReducer.actions
export default homeReducer.reducer
